import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=01ef79ab&"
import script from "./AdminCategories.vue?vue&type=script&lang=js&"
export * from "./AdminCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategories.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports